import React, { Fragment } from 'react';
import { Navigation, Users, TrendingUp, PiggyBank } from 'lucide-react';
// A single, light "perché te lo proponiamo" line used on opportunity cards on
// both the Host and Manutentore sides. Keep it to ONE muted row — no chrome.
interface MatchReasonProps {
  distanceKm?: number;
  savingsPercent?: number;
  efficiency?: string;
  peopleInZone?: number;
  peopleLabel?: string;
  className?: string;
}
function distanceLabel(km: number) {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km} km`;
}
export function MatchReason({
  distanceKm,
  savingsPercent,
  efficiency,
  peopleInZone,
  peopleLabel = 'in zona',
  className = ''
}: MatchReasonProps) {
  const parts: React.ReactNode[] = [];
  if (distanceKm != null) {
    parts.push(<span key="dist" className="inline-flex items-center gap-1" data-id="element-332">
        <Navigation size={12} className="flex-shrink-0" data-id="element-333" />a{' '}
        {distanceLabel(distanceKm)}
      </span>);
  }
  if (savingsPercent != null) {
    parts.push(<span key="save" className="inline-flex items-center gap-1 text-coral" data-id="element-334">
        <PiggyBank size={12} className="flex-shrink-0" data-id="element-335" />
        risparmi {savingsPercent}%
      </span>);
  }
  if (efficiency) {
    parts.push(<span key="eff" className="inline-flex items-center gap-1" data-id="element-336">
        <TrendingUp size={12} className="flex-shrink-0" data-id="element-337" />
        efficienza {efficiency}
      </span>);
  }
  if (peopleInZone != null) {
    parts.push(<span key="ppl" className="inline-flex items-center gap-1" data-id="element-338">
        <Users size={12} className="flex-shrink-0" data-id="element-339" />
        {peopleInZone} {peopleLabel}
      </span>);
  }
  if (parts.length === 0) return null;
  return <p className={`flex items-center gap-2 flex-wrap text-[11px] text-muted-foreground ${className}`} data-id="element-340">
      <span className="font-medium text-foreground/70" data-id="element-341">Perché:</span>
      {parts.map((p, i) => <Fragment key={i} data-id="element-342">
          {i > 0 && <span className="text-border" data-id="element-343">·</span>}
          {p}
        </Fragment>)}
    </p>;
}